import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLightBulbSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"light-bulb-simple, idea"} maskId="square-filled-radius-0-stroke-1-IconLightBulbSimple"><path d="M4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 12.9619 18.3902 15.5471 16 16.9296V17H8V16.9296C5.60976 15.5471 4 12.9619 4 10Z" fill="currentColor"/><path d="M8 18V19C8 21.2091 9.79086 23 12 23C14.2091 23 16 21.2091 16 19V18H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLightBulbSimple;
